import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["list", "view", "mainCard", "bodyTable", "footerTable", "checkboxShow", "clearListBtn", "optionBtn"]

  connect() {
    this.controllerName = `users--works--permissions--features--index`
    this.controllerNumber = this.getControllerByIdentifier(`app--helpers--numbers`)
    this.itemsOnPage = 500
    this.tableCols = 8
    this.pageNumber = 0
    this.numberPages = []
    this.sort = { mode: `desc`, field: `updated_at_to_time` }
    this.hasShow = false
    this.doIndexListHtml()
  }

  showFeature(ev) {
    var controllerShow = this.getControllerByIdentifier("users--works--permissions--features--show")
    var featureId = ev.target.closest(".itemRow").dataset.id

    this.application.features.forEach(element => {
      if (element.id == featureId) {
        controllerShow.current_feature = element
      }
    })

    controllerShow.doFeatureHtml()
  }

  addFeature() {
    this.clearListBtnTarget.classList.remove(`d-none`)
    this.optionBtnTarget.classList.add(`d-none`)
    
    this.getControllerByIdentifier("users--works--permissions--features--save").actionMode = "new"
    this.getControllerByIdentifier("users--works--permissions--features--save").current_feature = {}
    this.getControllerByIdentifier("users--works--permissions--features--save").doFormHtml()
  }

  uploadFeature() {
    this.getControllerByIdentifier("app--helpers--pre-upload").url_upload = `/users/permissions/features/upload`
    this.getControllerByIdentifier("app--helpers--pre-upload").url_download = `/users/permissions/features/download`
    this.getControllerByIdentifier("app--helpers--pre-upload").url_download_model = `/users/permissions/features/download`
    this.getControllerByIdentifier("app--helpers--pre-upload").method = `PUT`
    this.getControllerByIdentifier("app--helpers--pre-upload").feature = `Funcionalidades`
    this.getControllerByIdentifier("app--helpers--pre-upload").permission = `user_permissions_features`
    this.getControllerByIdentifier("app--helpers--pre-upload").model_fields = ["master", "group", "name", "humanize", "notes"]
    this.getControllerByIdentifier(`app--helpers--pre-upload`).openUploadModal()
  }

  downloadFeature() {
    this.getControllerByIdentifier("app--helpers--pre-upload").url_download = `/users/permissions/features/download`
    this.getControllerByIdentifier("app--helpers--pre-upload").method = `POST`
    this.getControllerByIdentifier("app--helpers--pre-upload").feature = `Funcionalidades`
    this.getControllerByIdentifier("app--helpers--pre-upload").permission = `user_permissions_features`
    this.getControllerByIdentifier("app--helpers--pre-upload").model_fields = ["id", "created_at", "master", "group", "name", "humanize", "notes"]
    this.getControllerByIdentifier(`app--helpers--pre-upload`).downloadData()
  }

  // editFeature(ev) {
  //   var id = ev.currentTarget.closest(".itemRow").dataset.id
  //   this.application.features.forEach(element => {
  //     if (element.id == id) {
  //       this.getControllerByIdentifier("users--works--permissions--features--save").current_feature = element
  //     }
  //   })
  //   this.getControllerByIdentifier("users--works--permissions--features--save").actionMode = "edit"
  //   this.getControllerByIdentifier("users--works--permissions--features--save").doFormHtml()
  // }

  sortTable(ev) {
    var mode = ev.currentTarget.dataset.mode
    var field = ev.currentTarget.dataset.field

    if (mode == `desc`) {
      ev.currentTarget.nextElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    } else if (mode == `asc`) {
      ev.currentTarget.previousElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    }

    this.sort.mode = mode
    this.sort.field = field
    this.doDataTable()
  }

  doIndexListHtml() {

    if (this.application.permissions.user_permissions_features.can_create) {
      var addLine = `<span data-action="click->${this.controllerName}#addFeature" class="dropdown-item py-1 pointer dropdown-submenu-item">Adicionar Funcionalidade</span>`
    } else {
      var addLine = ``
    }

    if (this.application.permissions.user_permissions_features.can_download) {
      var downloadLine = `<span data-action="click->${this.controllerName}#downloadFeature" class="dropdown-item py-1 pointer dropdown-submenu-item">Download de Funcionalidades</span>`
    } else {
      var downloadLine = ``
    }

    if (this.application.permissions.user_permissions_features.can_upload) {
      var uploadLine = `<span data-action="click->${this.controllerName}#uploadFeature" class="dropdown-item py-1 pointer dropdown-submenu-item">Upload de Funcionalidades</span>`
    } else {
      var uploadLine = ``
    }

    var refreshLine = `<span data-action="click->${this.controllerName}#refreshFeature" class="dropdown-item py-1 pointer dropdown-submenu-item">Atualizar Funcionalidades</span>`

    var clearBtnHtml = `<span class="mc-tooltip">
                          <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0 d-none" data-${this.controllerName}-target="clearListBtn" data-action="click->${this.controllerName}#clearList" type="button">
                            <span class="material-icons md-dark">clear</span>
                          </button>
                          <span class="mc-tooltiptext">Limpar</span>
                        </span>`

    var submenuHtml = `<div class="dropdown mc-tooltip" data-${this.controllerName}-target="optionBtn">
                        <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0" data-toggle="dropdown" id="submenuMenuDrop" type="button"><span class="material-icons md-dark">more_vert</span></button>
                        <div aria-labelledby="submenuMenuDrop" class="dropdown-menu dropdown-menu-right menu" style="font-size:80%">
                          ${addLine}
                          ${downloadLine}
                          ${uploadLine}
                          ${refreshLine}
                        </div>
                        <span class="mc-tooltiptext">Opções</span>
                      </div>`

    var html = `<div class="card" style="width:100%;display:relative;" data-controller="app--helpers--search" data-${this.controllerName}-target="mainCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4 card-title-table-list">Todas as Funcionalidades</h6>
                    <input class="form-control f-070 w-50 mx-auto" data-app--helpers--search-target="searchInput" data-action="keyup->app--helpers--search#doSearchTable" placeholder="Buscar ..." type="text">
                    <div class="card-actions ml-auto py-0">
                      ${clearBtnHtml}
                      ${submenuHtml}
                    </div>
                  </div>
                  <div class="card-body py-0" style="overflow:auto;">
                    <div class="row">
                      <div class="col p-0">
                        <table class="table table-sm table-hover" data-app--helpers--search-target="searchTable" style="font-size:80%;">
                          <thead>
                            <tr>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-15 align-middle">
                                Criado Em
                                <span class="material-icons md-sm md-dark" data-action="click->${this.controllerName}#sortTable" data-field="created_at_to_time" data-mode="desc">south</span>
                                <span class="material-icons md-sm md-dark d-none" data-action="click->${this.controllerName}#sortTable" data-field="created_at_to_time" data-mode="asc">north</span>
                              </th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-15 align-middle">
                                Atualização
                                <span class="material-icons md-sm md-dark" data-action="click->${this.controllerName}#sortTable" data-field="updated_at_to_time" data-mode="desc">south</span>
                                <span class="material-icons md-sm md-dark d-none" data-action="click->${this.controllerName}#sortTable" data-field="updated_at_to_time" data-mode="asc">north</span>
                              </th>

                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-10 align-middle">Master</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-10 align-middle">Grupo</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-20 align-middle">
                                Nome
                                <span class="material-icons md-sm md-dark" data-action="click->${this.controllerName}#sortTable" data-field="humanize" data-mode="desc">south</span>
                                <span class="material-icons md-sm md-dark d-none" data-action="click->${this.controllerName}#sortTable" data-field="humanize" data-mode="asc">north</span>
                              </th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-20 align-middle">
                                Enum
                                <span class="material-icons md-sm md-dark" data-action="click->${this.controllerName}#sortTable" data-field="name" data-mode="desc">south</span>
                                <span class="material-icons md-sm md-dark d-none" data-action="click->${this.controllerName}#sortTable" data-field="name" data-mode="asc">north</span>
                              </th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 align-middle text-center">Permissões</th>
                            </tr>
                          </thead>
                          <tbody data-${this.controllerName}-target="bodyTable">
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer py-0" data-${this.controllerName}-target="footerTable">
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("users--works--permissions--features--dashboard").listTarget.innerHTML = html)
    }).then(() => {
      controller.mainCardTarget.style.height = ($(window).height() * 0.6) + "px"
      controller.bodyTableTarget.insertAdjacentHTML("beforeend", controller.getControllerByIdentifier("app--helpers--table").doTablePreloader(this.tableCols, 10))
      controller.doDataTable()
    })
  }

  doDataTable() {
    var current_features = this.application.features

    if (this.sort.mode == `asc`) {
      var features = this.getControllerByIdentifier("app--helpers--data").sortByKeyAsc(current_features, this.sort.field)
    } else if (this.sort.mode == `desc`) {
      var features = this.getControllerByIdentifier("app--helpers--data").sortByKeyDesc(current_features, this.sort.field)
    }

    if (features.length == 0) {
      var pagination = { itemsOnPage: 0, fromItem: 0, toItem: 0, totalItems: 0 }
      this.listData()
      this.doFooterTable(pagination)
    } else {
      var itemsOnPage = this.itemsOnPage
      var pageNumber = this.pageNumber
      var numberPages = this.numberPages
      var pages = []
      var itemLoop = Math.ceil(features.length / itemsOnPage)
      var x = 0
      var i = 1
      for (i; i < itemLoop + 1; i++) {
        var internPage = []
        for (x; x < itemsOnPage * i; x++) {
          if (features[x] !== undefined) {
            internPage[internPage.length] = features[x]
          }
        }
        pages[pages.length] = internPage
        numberPages[numberPages.length] = i - 1
      }

      var fromItem = itemsOnPage * pageNumber + 1
      var toItem = Math.min(itemsOnPage * (pageNumber + 1), (itemsOnPage * pageNumber) + pages[pageNumber].length)
      var pagination = { itemsOnPage: itemsOnPage, fromItem: fromItem, toItem: toItem, totalItems: features.length }
      this.listData(pages[pageNumber])
      this.doFooterTable(pagination)
    }
  }

  listData(data) {
    this.bodyTableTarget.innerHTML = ""
    if (data == undefined || data == [] || data.length == 0) {
      var noData = `</tr>
                      <td colspan="${this.tableCols}" class="p-3 align-middle text-center" style="font-size:100%;">
                        <span class="fa-stack fa-1x">
                          <i class="fas fa-list fa-stack-1x"></i>
                        </span>
                        <span class="f-075 align-middle">Não há Funcionalidades</span>
                      </td>
                    </tr>`

      this.bodyTableTarget.innerHTML = noData
    } else {
      data.forEach(element => {
        this.bodyTableTarget.insertAdjacentHTML("beforeend", this.featureTablePartial(element, data.length))
      });
    }

    if (this.checked_id) {
      this.checkboxShowTargets.forEach(element => {
        if (element.id == `check-${this.checked_id}`) {
          element.checked = true
        }
      })
    }
  }

  featureTablePartial(element, length) {

    if (length == 1) {
      var tableRow = `<tr class="itemRow" data-id="${element.id}" style="height:50px;">`
    } else {
      var tableRow = `<tr class="itemRow" data-id="${element.id}">`
    }

    var rowHtml = `${tableRow}
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.created_at_pretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.updated_at_pretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle pointer" data-action="click->${this.controllerName}#showFeature">${element.master}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle pointer" data-action="click->${this.controllerName}#showFeature">${element.group}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle pointer" data-action="click->${this.controllerName}#showFeature">${element.humanize}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">
                      <span class="mc-tooltip grab">
                        <span data-controller="app--helpers--copy" data-copy="${element.name}" data-action="click->app--helpers--copy#copy">${element.name}</span>
                        <span class="mc-tooltiptext">Clique para copiar</span>
                      </span>
                    </td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">${element.total_permissions}</td>
                  </tr>`

    return rowHtml
  }

  itemsLength(ev) {
    this.itemsOnPage = ev.target.dataset.items
    this.pageNumber = 0
    this.numberPages = []
    this.doDataTable()
  }

  previousTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber - 1)) {
      this.pageNumber -= 1
      this.doDataTable()
    }
  }

  nextTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber + 1)) {
      this.pageNumber += 1
      this.doDataTable()
    }
  }

  doFooterTable(pagination) {
    var footerHtml = `<div class="row">
                        <div class="col-3 d-flex">
                          <div class="card-actions align-items-center justify-content-end py-0 f-065">
                            <span data-app--helpers--search-target="footerTable"></span>
                          </div>
                        </div>
                        <div class="col-9 px-0">
                          <div class="card-actions align-items-center justify-content-end py-0 f-065">
                            <span class="align-self-center mb-1 mx-1 text-muted">Itens por Página:</span>
                            <div class="dropdown">
                              <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline dropdown-toggle f-065" data-toggle="dropdown" type="button">${this.controllerNumber.numberMask(pagination.itemsOnPage)}</button>
                              <div class="dropdown-menu dropdown-menu-right menu">
                                <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="500">500</span>
                                <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="750">750</span>
                                <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="1000">1.000</span>
                              </div>
                            </div>
                            <span class="align-self-center mb-1 mr-2 text-muted">${this.controllerNumber.numberMask(pagination.fromItem)}-${this.controllerNumber.numberMask(pagination.toItem)} de ${this.controllerNumber.numberMask(pagination.totalItems)}</span>
                            <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#previousTablePage"><i class="material-icons md-sm">chevron_left</i></a>
                            <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#nextTablePage"><i class="material-icons md-sm">chevron_right</i></a>
                          </div>
                        </div>
                      </div>`

    this.footerTableTarget.innerHTML = footerHtml
  }

  clearList() {
    this.clearListBtnTarget.classList.add(`d-none`)
    this.optionBtnTarget.classList.remove(`d-none`)

    this.getControllerByIdentifier("users--works--permissions--features--save").stopRefreshing()
    this.getControllerByIdentifier("users--works--permissions--features--show").doViewHtml()
  }

  refreshFeature() {
    this.getControllerByIdentifier(`app--helpers--pre-modal`).openProcessModal()

    var data = { feature: { active: true }, current_user: { current_user_id: this.application.current_user.id } }
    const url = "/users/permissions/features/list"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.process) {
          controller.application.features = response.data.cln
        }
        
        controller.doDataTable()
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  

  cleanCheckBox() {
    this.checkboxShowTargets.forEach(element => {
      element.checked = false
    });
    this.checked_id = ``
  }

  userCanUpdate(ticketId) {
    var ticket = {}
    this.application.in_process_tickets.forEach(element => {
      if (element.id == ticketId) {
        ticket = element
      }
    })
    var allowed = [ticket.owner_id, ticket.performer_id]
    if (allowed.includes(this.application.current_user.account_id) && this.stage != "done") {
      return true
    } else {
      return false
    }
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      controller.validGroupTargets.forEach(element => {
        if (this.fromStringToBoolean(element.dataset.valid) == false) {
          len += 1
        }
      });
      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  goToURL(ev) {
    var url = ev.currentTarget.dataset.url
    window.open(url, `_self`)
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  mapElements(array, field) {
    var results = []
    array.forEach(element => {
      results[results.length] = element[field]
    });
    this.getControllerByIdentifier("app--helpers--console").console(results)
    return results
  }

  // var controller = this
  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
